import { render, staticRenderFns } from "./AttrText.vue?vue&type=template&id=29074ba0&scoped=true"
import script from "./AttrText.vue?vue&type=script&lang=js"
export * from "./AttrText.vue?vue&type=script&lang=js"
import style0 from "./AttrText.vue?vue&type=style&index=0&id=29074ba0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29074ba0",
  null
  
)

export default component.exports